// Asset URLs — replace these with real photos later.
export const ASSETS = {
  hero:
    "https://customer-assets-eiarnc6j.emergentagent.net/job_9d99a5e6-8218-468b-b690-56e0010f3316/artifacts/sr1m84d2_hero.jfif",
  room1:
    "https://customer-assets-eiarnc6j.emergentagent.net/job_9d99a5e6-8218-468b-b690-56e0010f3316/artifacts/ezsjkeb2_room%201.jfif",
  room2:
    "https://customer-assets-eiarnc6j.emergentagent.net/job_9d99a5e6-8218-468b-b690-56e0010f3316/artifacts/djwt4q48_room%202.JPG",
  room3:
    "https://customer-assets-eiarnc6j.emergentagent.net/job_9d99a5e6-8218-468b-b690-56e0010f3316/artifacts/6qoq5w4i_room%203.JPG",
  // Property / gallery photos
  gallery1:
    "https://customer-assets-jai6qajn.emergentagent.net/job_sardar-house-nathia/artifacts/id1508cw_gallery%201.jpeg", // garden bench in fog
  gallery2:
    "https://customer-assets-jai6qajn.emergentagent.net/job_sardar-house-nathia/artifacts/n6hs9g1d_gallery%202.jfif", // A-frame cabins in mist
  gallery3:
    "https://customer-assets-jai6qajn.emergentagent.net/job_sardar-house-nathia/artifacts/vn7qipfo_gallery%203.jfif", // dusk A-frame with amber glow
  gallery4:
    "https://customer-assets-jai6qajn.emergentagent.net/job_sardar-house-nathia/artifacts/0ib40d7u_gallery%204.jfif", // A-frames from stairs
  gallery5:
    "https://customer-assets-jai6qajn.emergentagent.net/job_sardar-house-nathia/artifacts/d50eqhmh_gallery%205.jfif", // single A-frame close-up
};

export const CONTACT = {
  phone: "0330 0606666",
  phoneRaw: "+923300606666",
  whatsapp: "923300606666",
  address: "Kalabagh Road, Nathia Gali, Pakistan",
};
